import Image from 'next/image';
import type {IGameInfo} from '@/services/dev-console/interfaces';

export default function GameCard({game}: {game: IGameInfo}) {
  const gameUrl = `/games/${game.id}/home`;

  return (
    <a
      href={gameUrl}
      className="flex items-center gap-4 rounded-[10px] bg-light-gray p-3 transition-shadow hover:shadow-md dark:bg-white/5"
    >
      <Image
        src={game.iconThumbnailUrl || game.iconUrl}
        width={55}
        height={55}
        alt={game.title}
        className="shrink-0 rounded-xl"
      />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-dark-gray dark:text-light-gray">
          {game.title}
        </p>
        {game.tagline && (
          <p className="truncate text-xs text-dark-gray/60 dark:text-light-gray/60">
            {game.tagline}
          </p>
        )}
        <p className="mt-0.5 text-xs text-primary-red">{game.primaryGenre}</p>
      </div>
      <span className="shrink-0 rounded-full bg-primary-blue px-4 py-1.5 text-xs font-bold text-white">
        GO
      </span>
    </a>
  );
}
